import React, { Component } from 'react';
import PromotedItem from './PromotedItem';
import Icon, { IconButton } from '@projeccions-pdc/react-icon';
import { isSmartphone } from '../../../helpers';
import AnalyticsService from '../../../apiclients/AnalyticsService';
import ContentService from '../../../apiclients/ContentService';
import FileDeliveryService from '../../../apiclients/FileDeliveryService';
import AppContext from '../../../AppContext';

import CircularProgress from '@material-ui/core/CircularProgress';
class PromotedSection extends Component {
    constructor(props) {
        super(props);
        this._isMounted = false;
        let appContext = new AppContext();
        let primaryColor = '#000';
        let domain = '';
        try {
            primaryColor = appContext.getPlatformConfig().customStyles.charlyHomeColor;
        } catch (err) {}
        try {
            domain = appContext.getConfig().PdcDomain;
        } catch (err) {}
        this.state = {
            open: false,
            promotedItems: { new: [], updated: [], promoted: [], top: [], suggested: [] },
            loaded: false,
            primaryColor,
            domain,
        };
        this.flicking = React.createRef();
        this.loadPromoteds();
    }

    loadPromoteds = async () => {
        try {
            let data = await ContentService.getPlatformDefinition();
            if (data.promoted === undefined) return;

            try {
                let analyticsData = await AnalyticsService.getSuggested();
                let contents = analyticsData.byContents.concat(analyticsData.byUsers);
                let contentsH = {};
                for (let c of contents) {
                    if (contentsH[c.contentId] === undefined) {
                        contentsH[c.contentId] = c;
                    }
                }

                contents = Object.values(contentsH);
                // Randomize array
                function shuffleArray(array) {
                    for (let i = array.length - 1; i > 0; i--) {
                        const j = Math.floor(Math.random() * (i + 1));
                        [array[i], array[j]] = [array[j], array[i]];
                    }
                }
                shuffleArray(contents);
                data.promoted['suggested'] = contents;
            } catch (err) {}
            let appContext = new AppContext();
            let { isAdmin, editor, member } = appContext.getMyInfo();

            let promotedItems = { promoted: [], new: [], updated: [], top: [], suggested: [] };
            let types = {
                new: { color: '#1656a6', name: 'New' },
                updated: { color: '#2e6e2d', name: 'Updated' },
                promoted: { color: '#f00', name: 'Promoted' },
                suggested: { color: '#9b9e00', name: 'Suggested' },
            };
            // TODO: Move this customisation outside!!
            if (this.state.domain === 'dbschenkersolutionhub.com') {
                types['new'] = { color: '#167d86', name: 'New' };
                types['updated'] = { color: '#878c96', name: 'Updated' };
            }
            //dbschenkersolutionhub.com
            for (let k of Object.keys(data.promoted)) {
                if (types[k] !== undefined) {
                    let total = 0;
                    for (let p of data.promoted[k].reverse()) {
                        // Is allowed and only the 15 first elements
                        if (
                            total < 15 &&
                            (p.groupId === undefined || isAdmin || editor.indexOf(p.groupId) !== -1 || member.indexOf(p.groupId) !== -1)
                        ) {
                            promotedItems[k].push({
                                name: p.name,
                                contentId: p.contentId,
                                type: {
                                    name: types[k].name,
                                    color: types[k].color,
                                },
                                img: FileDeliveryService.getFileURL(p.previewImage),
                            });
                            total++;
                        }
                    }
                }
            }

            // Create top round robin
            let c = { promoted: 0, new: 0, updated: 0 }; // This is priority order aswell
            let added = true;
            let total = 0;
            while (added === true && total < 12) {
                added = false;
                for (let k of Object.keys(c)) {
                    for (let i = 0; i < 2; i++) {
                        if (promotedItems[k].length > c[k]) {
                            promotedItems.top.push(promotedItems[k][c[k]++]);
                            added = true;
                            total++;
                        }
                    }
                }
            }
            // Sort
            promotedItems.top.sort((a, b) => {
                const aIndex = Object.keys(c).indexOf(a.type.name.toLowerCase());
                const bIndex = Object.keys(c).indexOf(b.type.name.toLowerCase());
                if (aIndex > bIndex) {
                    return 1;
                } else if (aIndex < bIndex) {
                    return -1;
                }
                return 0;
            });

            if (this._isMounted) this.setState({ promotedItems, loaded: true });
        } catch (err) {}
    };

    handleSizeChange = (match) => {
        if (this._isMounted) this.setState({ smartphoneView: match });
    };

    handleToggleOpen = () => {
        this.setState({ open: !this.state.open });
    };

    componentDidMount() {
        this._isMounted = true;
        this.removeListener = isSmartphone((match) => this.handleSizeChange(match));
    }

    componentWillUnmount() {
        this._isMounted = false;
        this.removeListener();
    }

    handleOpenResource = (contentId) => {
        this.props.onOpenResource({ resourceId: contentId, resourceType: 'content', resourceSubtype: 'm' });
    };

    render() {
        let elems = 0;
        for (let t of ['Promoted', 'New', 'Updated', 'Suggested']) {
            if (this.state.promotedItems[t.toLowerCase()].length > 0) elems++;
        }
        let height = (elems + 1) * 195;
        const overlayStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: '#0009',
            zIndex: 999,
        };
        let containerStyle = {
            /*position: 'absolute',
            bottom: 0,
            left: '50%',
            width: 'calc(90% - 150px)',
            marginLeft: '20px',
            transform: 'translate(-50%,0px)',
            top: 'calc(100vh - 248px)',
            backgroundColor: '#eee',
            padding: '15px',
            color: '#000',
            zIndex: 1000,
            transition: 'all 0.15s ease-in',*/
        };
        let containerOpenStyle = {
            height: undefined,
            top: `max(calc(100vh - ${height}px),0px)`,
            overflow: 'auto',
        };
        if (this.state.smartphoneView === true) {
            containerStyle = {
                /* position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                top: 'calc(100vh - 248px)',
                backgroundColor: '#eee',
                padding: '15px',
                color: '#000',
                zIndex: 1000,
                transition: 'all 0.15s ease-in',*/
            };
        }
        if (this.state.open === true) {
            containerStyle = { ...containerStyle, ...containerOpenStyle };
        }

        return (
            <div style={this.state.open ? overlayStyle : {}} onClick={this.state.open ? this.handleToggleOpen : undefined}>
                <div
                    style={containerStyle}
                    // className={this.state.smartphoneView ? 'promoted-container-smartphone' : 'promoted-container'}
                    className="promoted-container"
                    onClick={(e) => e.stopPropagation()}
                >
                    {this.state.loaded && (
                        <>
                            <span style={{ float: 'right', cursor: 'pointer', position: 'sticky', top: 0 }} onClick={this.handleToggleOpen}>
                                {this.state.open === false && (
                                    <>
                                        {'See More'}
                                        <Icon name="md-arrow-upward" />
                                    </>
                                )}
                                {this.state.open === true && (
                                    <>
                                        {'See Less'}
                                        <Icon name="md-arrow-downward" />
                                    </>
                                )}
                            </span>
                            {this.state.open === false && (
                                <>
                                    <h3>{'Top Content'}</h3>

                                    <PromotedSlider>
                                        {this.state.promotedItems['top'].map((promotedItem, i) => (
                                            <PromotedItem
                                                key={i}
                                                data={promotedItem}
                                                primrayColor={this.state.primaryColor}
                                                onOpen={this.handleOpenResource}
                                            />
                                        ))}
                                    </PromotedSlider>
                                </>
                            )}

                            {this.state.open === true &&
                                ['Promoted', 'New', 'Updated', 'Suggested'].map((filterType) => (
                                    <div key={filterType}>
                                        {this.state.promotedItems[filterType.toLowerCase()].length > 0 && (
                                            <>
                                                <h3>{filterType}</h3>
                                                <PromotedSlider>
                                                    {this.state.promotedItems[filterType.toLowerCase()].map((promotedItem, i) => (
                                                        <PromotedItem
                                                            key={i}
                                                            data={promotedItem}
                                                            primrayColor={this.state.primaryColor}
                                                            onOpen={this.handleOpenResource}
                                                        />
                                                    ))}
                                                </PromotedSlider>
                                            </>
                                        )}
                                    </div>
                                ))}
                        </>
                    )}
                    {!this.state.loaded && (
                        <div style={{ textAlign: 'center', paddingTop: 80 }}>
                            <CircularProgress style={{ color: this.state.primaryColor }} />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

class PromotedSlider extends Component {
    constructor(props) {
        super(props);
        this.container = React.createRef();
        this.state = { scrollLeft: 0, maxRight: true };
        this.timer = undefined;
    }

    componentDidMount() {
        this.setStateScrollPosition();
    }

    delaysetStateScrollPosition = () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.setStateScrollPosition();
        }, 500);
    };

    setStateScrollPosition = () => {
        try {
            this.setState({
                scrollLeft: this.container.current.scrollLeft,
                maxRight: this.container.current.offsetWidth + this.container.current.scrollLeft >= this.container.current.scrollWidth,
            });
        } catch (err) {}
    };

    scrollRight = () => {
        this.container.current.scrollBy(162, 0);
        this.delaysetStateScrollPosition();
    };

    scrollLeft = () => {
        this.container.current.scrollBy(-162, 0);
        this.delaysetStateScrollPosition();
    };

    render() {
        return (
            <div className="promoted-slider-container">
                <div ref={this.container} className="promoted-slider">
                    {this.props.children}
                </div>
                {this.state.scrollLeft > 0 && (
                    <div className="promoted-slider-left-arrow">
                        <IconButton
                            name={'fa-arrow-circle-left'}
                            padding={5}
                            primaryColor="#333"
                            secondaryColor="#ccc"
                            size="30px"
                            onClick={this.scrollLeft}
                        />
                    </div>
                )}
                {this.state.maxRight === false && (
                    <div className="promoted-slider-right-arrow">
                        <IconButton
                            name={'fa-arrow-circle-right'}
                            padding={5}
                            primaryColor="#333"
                            secondaryColor="#ccc"
                            size="30px"
                            onClick={this.scrollRight}
                        />
                    </div>
                )}
            </div>
        );
    }
}

export default PromotedSection;
